import { ConsumerSupportCaseCategory } from '@consumer/graphql'

export enum IssueType {
  PACKAGE_DAMAGED = 'packageDamaged',
  PACKAGE_MISSING = 'packageMissing',
  DRIVER_MISSED_INSTRUCTIONS = 'driverMissedInstructions',
  WRONG_PLACE = 'wrongPlace',
  DELIVERY_DELAYED = 'deliveryDelayed',
  ORDER_CONTENTS_ISSUE = 'orderContentsIssue',
  OTHER = 'other',
}

export const ISSUE_TYPE_LABELS = {
  [IssueType.PACKAGE_DAMAGED]: 'Package is damaged',
  [IssueType.PACKAGE_MISSING]: "I didn't receive my package",
  [IssueType.DRIVER_MISSED_INSTRUCTIONS]: 'Driver did not follow instructions',
  [IssueType.WRONG_PLACE]: 'I received my package, but it was left in a bad spot',
  [IssueType.DELIVERY_DELAYED]: 'My delivery is delayed',
  [IssueType.ORDER_CONTENTS_ISSUE]: 'Issue with my order contents',
  [IssueType.OTHER]: 'Other',
} as const

export const DEFLECTION_ISSUE_TYPES = new Set<IssueType>([IssueType.ORDER_CONTENTS_ISSUE])

export enum IssueSubmissionResult {
  SUCCESS = 'success',
  ALREADY_SUBMITTED = 'alreadySubmitted',
}

export interface IssueFormValues {
  trackingId: string
  issueType: string
  issueDetail: string
  name: string
  email: string
  cellPhone: string
  consentChecked: boolean
}

export type IssueTypeToCategoryMapper = (issueType: string) => ConsumerSupportCaseCategory
export type CategoryToIssueTypeMapper = (caseCategory: ConsumerSupportCaseCategory) => IssueType
